/**
 * Diagnostic Session - Shared run ID for tracing first-run flow
 * Each login/page load gets a unique ID to correlate all logs
 */

// Generate a session ID once per page load
const sessionId = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);

export const getRunId = () => sessionId;

export const diagLog = (component: string, message: string, data?: Record<string, unknown>) => {
  console.log(`[DIAG][${sessionId}][${component}] ${message}`, data ? JSON.stringify(data) : '');
};
